import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  perMonth: {
    description: 'per month abbreviation',
    defaultMessage: '/mo',
    id: '7IlSLs',
  },
  perMonthFullText: {
    description: 'per month not abbreviated',
    defaultMessage: '/month',
    id: '+NmJgT',
  },
  freeCost: {
    description: 'what is shown if the addon is free/$0',
    defaultMessage: 'Free',
    id: 'TCopzy',
  },
  tryForFree: {
    description: 'activate add-on button',
    defaultMessage: 'Try for Free',
    id: 'iqvnGd',
  },
  active: {
    description: 'image alternate text to display for the check circle icon',
    defaultMessage: 'Active',
    id: 'EGqXes',
  },
  trial: {
    description: 'captions to display if the add-on is active as a result of a trial',
    defaultMessage: 'Trial',
    id: 'pn3h24',
  },
  additionalFeesMayApply: {
    defaultMessage: '*Additional fees may apply',
    id: 'c1abgY',
    description: 'caption to display for certian add-ons that may have additional charges',
  },
  includedWithYourCurrentPlan: {
    defaultMessage: 'Included with your current plan',
    id: '8e3Vqp',
    description: 'caption to display if the add-on is already included with your current plan',
  },
  deactivationDate: {
    description: 'the date the add-on will deactivate',
    defaultMessage: 'Deactivates {deactivationDt}',
    id: '4aLIju',
  },
  freeForXDays: {
    defaultMessage: 'Free for {formattedDays} {trialLengthInDays, plural, one {day} other {days}}',
    id: 'mbFT1A',
    description: 'Message for sellers indicating how long the trial will be for',
  },
  dueToday: {
    description: 'text displayed when showing how much the user will have to pay if they activate the add-on today',
    defaultMessage: 'Due Today',
    id: 'mBtFfK',
  },
  defaultDeactivateErrorMessage: {
    description: 'error message displayed if there is an error returned when trying to Deactivate the Add-On',
    defaultMessage: 'Failed to deactivate. Please try again.',
    id: 'ZKJ/SK',
  },
  defaultActivateErrorMessage: {
    description: 'error message displayed if there is an error returned when trying to Activate the Add-On',
    defaultMessage: 'Failed to activate. Please try again.',
    id: 'lkiVZ/',
  },
  closeErrorMessage: {
    description: 'alt text for accessibility for the close button on the Error message displayed',
    defaultMessage: 'close error',
    id: 'u76rHn',
  },
  errorIconMessage: {
    description: 'alt text for accessibility for the error icon displayed when an error occurs',
    defaultMessage: 'error',
    id: 'bxL8cM',
  },
  configure: {
    description: 'button text to link user to add-on configuration page',
    defaultMessage: 'Configure Settings',
    id: 'pJZWyb',
  },
  viewDetails: {
    description: 'button text to open the Add-On Modal',
    defaultMessage: 'View Details',
    id: 'bJxooi',
  },
  activate: {
    description: 'button text to specifically open ReturnRabbit Add-On Modal',
    defaultMessage: 'Activate',
    id: 'TEjLdU',
  },
  openReturnRabbit: {
    description: 'button text to specifically open a new tab to ReturnRabbit website',
    defaultMessage: 'Open Return Rabbit',
    id: 'uFD7o/',
  },
  trialDaysRemaining: {
    description:
      'banner message displayed for sellers who are trialing an add-on which tells them how many more days before their trial ends',
    defaultMessage: 'Free trial ends in {daysCount} day(s).',
    id: 'y0DLC4',
  },
  trialExpiringSoon: {
    description: 'banner message displayed for when the trial has expired but the data being returned still shows the user in a trial',
    defaultMessage: 'Your trial is expiring soon.',
    id: '9LZB0j',
  },
});
